// export const BACKEND_URL = 'http://127.0.0.1:4523/m1/1487514-0-default';
export const BACKEND_URL = 'https://api.whichtool.xyz/api/v1/tools';

export const NFT_STORAGE_TOKEN =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJkaWQ6ZXRocjoweGFiZWE3Y0UyQTRERThBY0NDMEFjNThCOTZDNTQxNGY1MWFiMUJFQkUiLCJpc3MiOiJuZnQtc3RvcmFnZSIsImlhdCI6MTY2MTE4MjczMzU3MywibmFtZSI6IndoaWNodG9vbCJ9.rvFXmOjgewjfNO9SB4lUtzwAkF97IIVscEc9cK3HTNQ';
